import Reveal from 'react-awesome-reveal';
import { fadeInRightShorter } from '../../../utils/data/keyframes';
import ProductHomeCard from './product-home-card';
import { useRouter } from 'next/router';

export default function FeaturedCollection(props) {
  const { product, loading, title } = props;
  const router = useRouter();
  const { query } = router;

  return (
    <div className="feature-container">
      <h2 className="home-subtitle">{title}</h2>
      <div className="bedroom-feature-wrap">
        {loading
          ? [0, 1, 2, 3, 4].map((item, index) => (
              <div
                className="col-6 col-sm-4 col-md-3"
                key={'product-one' + index}>
                <div className="skel-pro skel-pro-grid"></div>
              </div>
            ))
          : product?.map((item, index) => (
              <div className="bedroom-feature-card" key={'product-one' + index}>
                <Reveal
                  keyframes={fadeInRightShorter}
                  delay={100}
                  duration={1500}
                  triggerOnce>
                  <ProductHomeCard
                    isImageWithDomain={true}
                    product={item}
                    manualUrlRedirect={
                      item?.store_type === 'electronics'
                        ? `${process.env.ELECTRONICS_URL}${item.slug}?${new URLSearchParams(query).toString()}`
                        : `${process.env.FURNITURE_URL}/product/default${item.slug}?${new URLSearchParams(query).toString()}`
                    }
                  />
                </Reveal>
              </div>
            ))}
      </div>
    </div>
  );
}